import { Bell } from "lucide-react";

const ALERT_OPTIONS = ["10 min before", "30 min before", "1 hour before", "1 day before"];

export default function EventForm({ newEvent, setNewEvent, onSubmit }) {
  return (
    <div className="border border-zinc-800 bg-[#0A0A0A] p-5 mt-5 space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="font-label block mb-2">Date</label>
          <input
            type="date"
            data-testid="event-date-input"
            value={newEvent.date}
            onChange={(e) => setNewEvent({ ...newEvent, date: e.target.value })}
            className="w-full bg-[#141414] border border-zinc-800 px-3 py-2.5 text-sm focus:border-red-600 focus:outline-none"
          />
        </div>
        <div>
          <label className="font-label block mb-2">Time</label>
          <input
            type="time"
            data-testid="event-time-input"
            value={newEvent.time}
            onChange={(e) => setNewEvent({ ...newEvent, time: e.target.value })}
            className="w-full bg-[#141414] border border-zinc-800 px-3 py-2.5 text-sm focus:border-red-600 focus:outline-none"
          />
        </div>
      </div>
      <div>
        <label className="font-label block mb-2">Event</label>
        <input
          data-testid="event-title-input"
          placeholder="ex: Gi class"
          value={newEvent.title}
          onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
          className="w-full bg-[#141414] border border-zinc-800 px-3 py-2.5 text-sm focus:border-red-600 focus:outline-none"
        />
      </div>
      <div>
        <label className="font-label block mb-2">Alert</label>
        <select
          data-testid="event-alert-select"
          value={newEvent.alert}
          onChange={(e) => setNewEvent({ ...newEvent, alert: e.target.value })}
          className="w-full bg-[#141414] border border-zinc-800 px-3 py-2.5 text-sm focus:border-red-600 focus:outline-none"
        >
          {ALERT_OPTIONS.map((opt) => (
            <option key={opt}>{opt}</option>
          ))}
        </select>
      </div>
      <button
        onClick={onSubmit}
        data-testid="add-event-button"
        className="w-full bg-red-600 hover:bg-red-700 text-white font-heading tracking-wider py-3 flex items-center justify-center gap-2"
      >
        <Bell className="w-4 h-4" strokeWidth={3} /> Set Alert
      </button>
    </div>
  );
}
